import styled from 'styled-components';

import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { fontWeights } from 'ui/theme';

const BoldText = styled.b`
  font-weight: ${fontWeights.bold};
`;

const displayText = {
  header: 'Export journeys data to CSV',
  confirm: 'Export to CSV',
  body: (
    <>
      Are you sure that you want to export <BoldText>all journeys data to CSV</BoldText>?
    </>
  ),
};

type ExportCsvDialogProps = {
  onConfirm: () => void;
  onClose: () => void;
};

export const ExportCsvDialog = ({ onConfirm, onClose }: ExportCsvDialogProps) => {
  return (
    <Modal
      data-test="export-workflow-to-csv-modal-wrapper"
      id="export-workflow-to-csv-modal"
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader data-test="export-workflow-to-csv-modal-header">
        {displayText.header}
      </ModalHeader>
      <ModalBody
        data-test="export-workflow-to-csv-modal-body"
        id="export-workflow-to-csv-modal-body"
      >
        {displayText.body}
      </ModalBody>
      <ModalFooter
        data-test="export-workflow-to-csv-modal-actions"
        id="export-workflow-to-csv-modal-actions"
      >
        <PrimaryButton
          onClick={onConfirm}
          data-test="export-workflow-to-csv-modal-confirm-button"
          size={BUTTON_SIZES.LARGE}
        >
          {displayText.confirm}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
